import React from 'react';
import {
	BrowserRouter,
	Redirect,
	Route,
	Switch
} from 'react-router-dom';

import { log } from '../../services/utils';

import { useAuthState } from '../../contexts/AuthContext';

import Administration from './Administration';
import Agencies from './Agencies';
import Dashboard from './Dashboard';
import Header from '../Header';
import Operations from './Operations';
// import Reports from './Reports';
import Sidebar from '../Sidebar';
import TimeoutModal from '../TimeoutModal';
import UnlockNavConfirm from '../Shared/UnlockNavConfirm';

const ManagementRouter = () => {
	const { user: { permissions } } = useAuthState();

	return (
		<BrowserRouter>
			{ log( 'managementRouter' ) }
			<div className="app-container" >
				<Sidebar />
				<div className="content-container">
					<Header />
					<div className="content-wrapper">
						<Switch>
							<Route
								path="/dashboard"
								component={ Dashboard }
							/>
							{ permissions.listContacts.isAvailable || permissions.listPrograms.isAvailable || permissions.listCalendarEvents.isAvailable
								? <Route
									path="/operations"
									component={ Operations }
								/>
								: null
							}
							{/* <Route path="/reports" component={ Reports } /> */}
							{ permissions.listAgencies.isAvailable
								? <Route
									path="/agencies"
									component={ Agencies }
								/>
								: null
							}
							{ permissions.listUsers.isAvailable
								? <Route
									path="/administration"
									component={ Administration }
								/>
								: null
							}
							<Redirect
								from="*"
								to="/dashboard"
							/>
						</Switch>
					</div>
				</div>
			</div>
			<UnlockNavConfirm />
			<TimeoutModal />
		</BrowserRouter>
	);
};

export default ManagementRouter;
